import type { EvidenceBalance } from "../types";

export function EvidenceBalanceBadge({ value }: { value?: EvidenceBalance | null }) {
  if (!value) return <span className="status-badge status-badge-muted">Balance unavailable</span>;
  const label = value === "YES" ? "Leans YES" : value === "NO" ? "Leans NO" : "PASS";
  return <span className={`status-badge status-badge-${value.toLowerCase()}`}><span aria-hidden="true" className="status-badge-dot" />{label}</span>;
}
